import {
    useCallback,
} from 'react'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import {
    useGetRequestSpreadSheetAdapter,
} from 'app/shared-components/SkyNetSpreadSheet'
import useSimpleApiRequest from 'app/hooks/useSimpleApiRequest'
import StatusHandler from 'app/shared-components/StatusHandler'
import {
    AsyncMutationOptions,
} from 'app/types/request.types'
import useFilter from 'app/hooks/useFilter'
import {
    useSkyNetPagination, SkyNetPaginationContext,
} from 'app/shared-components/SkyNetPagination'
import requests from 'app/requests/RateCard.requests'
import {
    BaseLeaseEditable,
    BaseLeaseTable,
} from '../BaseLease.types'
import BaseLeaseSpreadsheet from '../BaseLeaseSpreadsheet'
import {
    prepareBaseLeaseToBulkEdit,
} from '../BaseLease.utils'
import defaultRateCardsBulkSort from '../../RateCardsBulkEdit/RateCardsBulkEdit.utils'

export default function BaseLeaseBulkEdit({
    onClose,
}: {
    onClose: () => void
}) {
    const filterOptions = useFilter<BaseLeaseTable[]>()
    const paginationOptions = useSkyNetPagination(100)

    const {
        isError,
        loaded,
        error,
        refetch,
    } = useGetRequestSpreadSheetAdapter<BaseLeaseTable>({
        config: requests.baseLeaseFilterRequest,
        requestKey: RequestKeys.getBaseLeaseRateCards,
        enabled: true,
        filterOptions,
        paginationOptions,
        defaultSort: defaultRateCardsBulkSort,
    })

    const {
        mutateAsync: bulkEdit,
    } = useSimpleApiRequest<{ items: BaseLeaseEditable[] }>({
        name: 'BaseLeaseBulkUpdate',
        title: 'Base Lease Rate Cards were updated',
        requestParams: requests.baseLeaseBulkEdit(),
        onSuccess: refetch,
    })

    const onSave = useCallback(async (
        items: BaseLeaseTable[],
        options?: AsyncMutationOptions,
    ) => {
        await bulkEdit({
            items: prepareBaseLeaseToBulkEdit(items),
        }, {
            ...options,
            onSuccess: options?.onSuccess || onClose,
        })
    }, [
        bulkEdit,
        onClose,
    ])

    return (
        <StatusHandler
            isError={isError}
            isFetching={!loaded}
            error={error}
            isSuccess={loaded}
        >
            <SkyNetPaginationContext.Provider value={paginationOptions}>
                <BaseLeaseSpreadsheet
                    filterOptions={filterOptions}
                    onCancel={onClose}
                    onSave={onSave}
                />
            </SkyNetPaginationContext.Provider>
        </StatusHandler>
    )
}
